module.exports = __webpack_public_path__ + "static/media/img03.6edba7c5.png";